import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import { InputField } from "../../../Components/formElements/InputField";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import WorkflowApproveReject from "../../../Components/Workflow/WorkflowApproveReject";
import PQQuestionnaireTabs from "../../../Components/PQ/PQQuestionnaireTabs";
import { formatDateTime } from "../../../common/Validations";
import {
  getPQVendorDetail,
  getPQWorkflowDetail,
} from "../../../redux/feature/supplier_app/pqVendorSlice";

const PQWorkflowDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "PQ Vendor");
  localStorage.setItem("submenu", "PQ Vendor List");

  const pqVendorId = useSelector(
    (state) => state?.pqVendor?.pqDetail?.pqVendorId
  );
  const detail = useSelector((state) => state?.pqVendor?.pqDetail?.data) || {};
  const pqWorkflow = useSelector((state) => state?.pqVendor?.pqWorkflow) || {};
  const workflowRecord = pqWorkflow.workflow_record;
  const logs = pqWorkflow.logs || [];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isQuestionnaireVisible, setQuestionnaireVisible] = useState(true);

  useEffect(() => {
    if (pqVendorId) {
      dispatch(getPQVendorDetail({ pqVendorId }));
      dispatch(getPQWorkflowDetail({ pqVendorId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pqVendorId]);

  useEffect(() => {
    if (!pqVendorId) {
      navigate(Constants.PQ_VENDOR_LIST);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pqVendorId]);

  /* mirror of the list pipeline status derivation: Reject -> Registered
   * (workflow completed) -> In Registration (workflow running) -> raw status */
  const derivedStatus = (() => {
    if (logs.some((item) => item.currentAction === "Reject")) return "Reject";
    if (
      logs.some(
        (item) =>
          item.stepType === "Completion_Task" &&
          item.workflowStatus === "Closed"
      )
    )
      return "Registered";
    if (logs.length > 0) return "In Registration";
    return detail.status || "";
  })();

  const statusValue = derivedStatus;
  const isOpenWorkflow = workflowRecord?.workflowStatus === "Open";

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <h2 className="mainTitle">
                  PQ Workflow Details{" "}
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {pqVendorId || "--"}
                  </span>
                </h2>
                <p className="subText">
                  Review the pre-qualification assessment and approve / reject
                </p>
              </Col>
              <hr />
            </Row>

            <div className="mt-2 mb-3">
              <TableStatusField status={statusValue} />
            </div>

            {isOpenWorkflow && workflowRecord?.currentApprover && (
              <p className="subText mb-3">
                Pending with {workflowRecord.currentApprover}
                {workflowRecord?.stepName ? ` - ${workflowRecord.stepName}` : ""}
              </p>
            )}

            {/* 01 Assessment Details */}
            <div className="accordion mb-4" id="pqWorkflowDetailsAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={() => setCardVisible(!isCardVisible)}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PQ</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Assessment Details</span>
                      <span className="subHeaderTitle">
                        Vendor pre-qualification summary
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="text-end pe-3">
                      <span className="headerStatusDetailedPage">
                        {detail.sourceType || "Assessment"}
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PQ Vendor ID"
                          name="pqVendorId"
                          id="pqVendorId"
                          placeholder=""
                          value={detail.pqVendorId || pqVendorId || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Supplier ID"
                          name="supplierId"
                          id="supplierId"
                          placeholder=""
                          value={detail.supplierId || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status"
                          name="status"
                          id="status"
                          placeholder=""
                          value={statusValue}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyName"
                          id="companyName"
                          placeholder=""
                          value={
                            detail.companyName ||
                            detail.organisationName ||
                            detail.invitation?.companyName ||
                            ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          id="email"
                          placeholder=""
                          value={detail.email || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Reference No"
                          name="referenceNumber"
                          id="referenceNumber"
                          placeholder=""
                          value={detail.referenceNumber || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Category"
                          name="category"
                          id="category"
                          placeholder=""
                          value={detail.category || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Submitted At"
                          name="submittedAt"
                          id="submittedAt"
                          placeholder=""
                          value={
                            detail.submittedAt
                              ? formatDateTime(detail.submittedAt)
                              : "--"
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              {/* 02 Questionnaire */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isQuestionnaireVisible
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={() =>
                          setQuestionnaireVisible(!isQuestionnaireVisible)
                        }
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QN</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Questionnaire</span>
                      <span className="subHeaderTitle">
                        {detail.hasSubmission
                          ? "Submitted questionnaire response"
                          : "Questionnaire not submitted yet"}
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="text-end pe-3">
                      <span className="headerStatusDetailedPage">
                        {detail.sourceType || "Invitation"}
                      </span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isQuestionnaireVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <PQQuestionnaireTabs detail={detail} />
                  </div>
                </div>
              </div>
            </div>

            {/* Approve / Reject (shared workflow component) */}
            {workflowRecord ? (
              <WorkflowApproveReject
                key={workflowRecord._id}
                workflowData={{ workflow_record: workflowRecord }}
              />
            ) : (
              <Row className="mb-4">
                <Col xs={12} md={12} lg={12} className="text-left">
                  <button
                    className="btnBack"
                    onClick={() => navigate(Constants.PQ_VENDOR_LIST)}
                  >
                    <i className="bi bi-arrow-return-left"></i> Go Back
                  </button>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default PQWorkflowDetails;
